import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutEquipmentTypeList extends Layout {
    sourceEquipmentType: DataSource;
    tableEquipmentType: Table;
}
